import React from 'react';

// Brand logos as text/SVG components (matching Shorebird style)
const brandLogos = [
  { name: 'solides', style: 'font-light tracking-wide' },
  { name: 'JUNGLE', style: 'font-bold tracking-tight', subtitle: 'GAMES' },
  { name: 'kijiji', style: 'font-medium', hasIcon: true },
  { name: 'TRACKER', style: 'font-bold tracking-widest' },
  { name: 'CHAI', style: 'font-semibold tracking-wide', hasIcon: true },
  { name: 'Kalshi', style: 'font-semibold' },
  { name: 'ApnaKlub', style: 'font-medium', hasIcon: true },
  { name: 'FLASH.CO', style: 'font-bold tracking-tight', prefix: 'F.' },
  { name: 'trade', style: 'font-medium', hasIcon: true },
];

const LogoItem = ({ logo }: { logo: typeof brandLogos[0] }) => {
  if (logo.name === 'JUNGLE') {
    return (
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 border-2 border-white/40 rounded-lg flex items-center justify-center">
          <div className="grid grid-cols-2 gap-0.5">
            <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
            <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
            <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
            <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-white/50 text-lg font-bold tracking-tight leading-none">JUNGLE<span className="text-[#ff3b3b]">E</span></span>
          <span className="text-white/30 text-[8px] tracking-[0.2em]">GAMES</span>
        </div>
      </div>
    );
  }
  
  if (logo.name === 'kijiji') {
    return (
      <span className="text-white/50 text-xl font-medium">
        ki<span className="text-white/40">j</span>i<span className="relative">j<span className="absolute -top-1 -right-1 w-1 h-1 bg-white/40 rounded-full"></span></span>i
      </span>
    );
  }
  
  if (logo.name === 'TRACKER') {
    return (
      <span className="text-white/50 text-xl font-bold tracking-widest">
        TR<span className="text-[#ff3b3b]">A</span>CKER
      </span>
    );
  }
  
  if (logo.name === 'CHAI') {
    return (
      <div className="flex items-center gap-2">
        <div className="flex">
          <div className="w-4 h-2 bg-white/40 rounded-full"></div>
          <div className="w-4 h-2 bg-white/40 rounded-full -ml-1"></div>
        </div>
        <span className="text-white/50 text-xl font-semibold tracking-wide">CHAI</span>
      </div>
    );
  }
  
  if (logo.name === 'ApnaKlub') {
    return (
      <div className="flex items-center gap-1.5">
        <div className="flex gap-0.5">
          <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
          <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
          <div className="w-1.5 h-1.5 bg-white/40 rounded-full"></div>
        </div>
        <span className="text-white/50 text-lg font-medium">ApnaKlub</span>
      </div>
    );
  }
  
  if (logo.name === 'FLASH.CO') {
    return (
      <span className="text-white/50 text-xl font-bold tracking-tight">
        <span className="text-[#ff3b3b]">F.</span>FLASH.CO
      </span>
    );
  }
  
  if (logo.name === 'trade') {
    return (
      <div className="flex items-center gap-1.5">
        <div className="w-4 h-4 bg-white/40 rounded transform rotate-45"></div>
        <span className="text-white/50 text-lg font-medium">trade</span>
      </div>
    );
  }
  
  return (
    <span className={`text-white/50 text-xl ${logo.style}`}>
      {logo.name}
    </span>
  );
};

const ClientLogosSection: React.FC<{ isHeroInlined?: boolean }> = ({ isHeroInlined }) => {
  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...brandLogos, ...brandLogos];
  
  return (
    <section className={`${isHeroInlined ? 'py-4 bg-transparent' : 'py-12 bg-[#0a0d14]'} overflow-hidden w-full`}>
      {/* Infinite scrolling marquee */}
      <div className="relative">
        {/* Gradient fade on edges - only if not inlined */}
        {!isHeroInlined && (
          <>
            <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0d14] to-transparent z-10 pointer-events-none"></div>
            <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0d14] to-transparent z-10 pointer-events-none"></div>
          </>
        )}
        
        <div 
          className="flex items-center gap-16 whitespace-nowrap animate-marquee"
          style={{
            animation: 'marquee 30s linear infinite',
          }}
        >
          {duplicatedLogos.map((logo, i) => (
            <div 
              key={`${logo.name}-${i}`} 
              className="flex-shrink-0 px-4 hover:opacity-100 opacity-70 transition-opacity duration-300 cursor-pointer"
            >
              <LogoItem logo={logo} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogosSection;
